module.exports = __webpack_public_path__ + "img/ico_gzyq.a394e86d.png";